export function filterInPlace(array, test, context) {
    var target = 0;
    array.forEach(function (elem, i) {
        if (test.call(this, elem, i, array)) {
            array[target++] = elem;
        }
    }, context);
    array.length = target;
    return array;
}
//# sourceMappingURL=filterInPlace.js.map


//////////////////
// WEBPACK FOOTER
// ./~/apollo-utilities/lib/util/filterInPlace.js
// module id = nEq4
// module chunks = 0